import { type SVGProps } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}

const ClockRegular = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={12}
    height={12}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d='M6 0a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6Zm2.6 8.61a.508.508 0 0 1-.706.032l-2.48-2.273A.5.5 0 0 1 5.25 6V3.25a.5.5 0 1 1 1 0v2.53l2.317 2.124a.5.5 0 0 1 .033.707Z'
      fill='#08033B'
    />
  </svg>
)

export { ClockRegular }
